import { style } from "@mui/system";


function MenuCard({items, key}) {
    return (
        <>
            <div style={styles.container} key={key} >
                <div style={styles.top} >
                    <p >{items.title}</p>
                    <p >{items.price}</p>
                </div>
                <p>{items.description}</p>
            </div>
        </>
    );
};

export default MenuCard;

const styles = {
    container: {
        flexDirection: 'row',
    },
    top: {
        display: 'flex',
        justifyContent: 'space-between',
    }
}